var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('v-idle',{attrs:{"loop":false,"reminders":[10, 15],"wait":5,"duration":1800},on:{"idle":_vm.onidle,"remind":_vm.onremind}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }